import React, { useState } from 'react';
import closeIcon from '../../assets/Close.png';
import uploadIcon from '../../assets/Rectangle22.png';
import shareIcon from '../../assets/Share.png';
import { embedApplyJob } from '../services/operations/jobPostAPI';
import { useDispatch } from 'react-redux';
import toast from 'react-hot-toast';
import { message } from '../messages/Message';

const ApplyJob = ({ jobId, isOpen, onClose }) => {
  const [files, setFiles] = useState([]);
  const [totalProgress, setTotalProgress] = useState(0);
  const dispatch = useDispatch()
  const ALLOWED_TYPES = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];


  const handleModalClose = () => {
    setFiles([]);
    setTotalProgress(0);
    onClose();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) handleFiles([file]);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) handleFiles([file]);
  };


  const handleFiles = async (fileList) => {
    const file = fileList[0];

    if (!ALLOWED_TYPES.includes(file.type)) {
      toast.error(message.fileUploadeErrorMessage);
      return;
    }

    setFiles([file]);
    setTotalProgress(0);

    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      setTotalProgress(progress);
      if (progress >= 90) clearInterval(interval);
    }, 200);


    const formData = new FormData();
    formData.append("files", file);
    formData.append("job_id", jobId);
    formData.append("uploadDateTime", btoa(JSON.stringify(new Date().toISOString())));
    formData.append("fileCount", 1);
    formData.append("uploaded_portal", "candidate");

    const result = await dispatch(embedApplyJob(formData, onClose));
    clearInterval(interval);

    if (result) {
      setTotalProgress(100);
      setTimeout(() => {

        handleModalClose();
      }, 1500);
    }
  };



  const formatFileSize = (size) => {
    if (size < 1024) return size + ' bytes';
    if (size < 1024 * 1024) return (size / 1024).toFixed(2) + ' KB';
    return (size / (1024 * 1024)).toFixed(2) + ' MB';
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ width: "860px" }}>
        <div className='upload-heading'>
          <h6>Upload your resume to apply this Job</h6>
          <img src={closeIcon} alt="Close" className="close-icon" onClick={handleModalClose} />
        </div>

        {!files.length ? (
          <div
            className="drag-drop-area"
            onDragOver={(e) => e.preventDefault()}
            onDrop={handleDrop}
            onClick={() => document.getElementById("fileInput").click()}
          >
            <div className="icon-container">
              <img src={uploadIcon} alt="Upload" className="upload-icon" />
              <img src={shareIcon} alt="Share" className="share-icon" />
              <input
                id="fileInput"
                type="file"
                accept='doc,docx,pdf'
                onChange={handleFileChange}
                style={{ display: 'none' }}
              />
            </div>
          </div>
        ) : (
          <div className="file-info">
            <div className="file-details">
              <div className="file-size">
                <p>{files[0].name}</p>
                <span>{formatFileSize(files[0].size)}</span>
              </div>
            </div>
            <div className="progress-bar-containers">
              <div className="progress-bars">
                <div
                  style={{
                    width: `${totalProgress}%`,
                    backgroundColor: "#002DCC",
                    height: "8px",
                    transition: "width 0.25s ease-in-out",
                  }}
                ></div>
              </div>
              <span>{totalProgress}%</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ApplyJob;
